import { render, staticRenderFns } from "./tab-2.vue?vue&type=template&id=1e4a616d"
import script from "./tab-2.vue?vue&type=script&lang=js"
export * from "./tab-2.vue?vue&type=script&lang=js"
import style0 from "./tab-2.vue?vue&type=style&index=0&id=1e4a616d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports